import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "info-block"
}
const _hoisted_2 = {
  key: 0,
  class: "info"
}
const _hoisted_3 = {
  key: 1,
  class: "info"
}
const _hoisted_4 = {
  key: 2,
  class: "info"
}
const _hoisted_5 = {
  key: 3,
  class: "info"
}
const _hoisted_6 = {
  key: 4,
  class: "info"
}
const _hoisted_7 = {
  key: 5,
  class: "info"
}
const _hoisted_8 = {
  key: 6,
  class: "info"
}
const _hoisted_9 = {
  key: 7,
  class: "info"
}
const _hoisted_10 = {
  key: 8,
  class: "info"
}
const _hoisted_11 = {
  key: 9,
  class: "info"
}
const _hoisted_12 = {
  key: 10,
  class: "info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showGameInfoBlock)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.gameData.rtp)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.combinedData.rtp), 1))
          : _createCommentVNode("", true),
        (_ctx.gameData.lines)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.combinedData.lines), 1))
          : _createCommentVNode("", true),
        (_ctx.gameData.ways)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.combinedData.ways), 1))
          : _createCommentVNode("", true),
        (_ctx.gameData.freeSpin)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.combinedData.freeSpin), 1))
          : _createCommentVNode("", true),
        (_ctx.gameData.features)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.combinedData.features), 1))
          : _createCommentVNode("", true),
        (_ctx.gameData.coinSpin)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.combinedData.coinSpin), 1))
          : _createCommentVNode("", true),
        (_ctx.gameData.wheels)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.combinedData.wheels), 1))
          : _createCommentVNode("", true),
        (_ctx.gameData.avalanche)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.combinedData.avalanche), 1))
          : _createCommentVNode("", true),
        (_ctx.gameData.cascade)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.combinedData.cascade), 1))
          : _createCommentVNode("", true),
        (_ctx.gameData.jackpotGame)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.combinedData.jackpotGame), 1))
          : _createCommentVNode("", true),
        (_ctx.gameData.featuresBuy)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.combinedData.featuresBuy), 1))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}